export function getErrorMessage(error: unknown, fallback: string) {
  return error instanceof Error && error.message ? error.message : fallback
}

export function getFirstSchemaError(error: { issues: Array<{ message: string }> }) {
  return error.issues[0]?.message ?? '表单内容不符合要求'
}
